import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

import { FaBusAlt, FaHotel } from "react-icons/fa";
import { IoTrainOutline } from "react-icons/io5";
import { GiCommercialAirplane } from "react-icons/gi";
import { IoAirplaneOutline } from "react-icons/io5";

const Reserve = () => {
  let location = useLocation();
  const { pathname } = location;

  console.log(pathname);

  return (
    <Reservation>
      <List>
        <li className={pathname ==="/train-ticket" ? 'activeReserve' : null}>
          <Link to={"train-ticket"}>
            <span>
              <IoTrainOutline />
            </span>
            قطار
          </Link>
        </li>
        <li className={pathname ==="/bus-ticket" ? 'activeReserve' : null}>
          <Link to={"bus-ticket"}>
            <span>
              <FaBusAlt />
            </span>
            اتوبوس
          </Link>
        </li>
        <li className={pathname ==="/hotel-reservation" ? 'activeReserve' : null}>
          <Link to={"hotel-reservation"}>
            <span>
              <FaHotel />
            </span>
            هتل{" "}
          </Link>
        </li>
        <li className={pathname ==="/iranout" ? 'activeReserve large-Screen':"large-Screen "}>
          <Link to={"iranout"}>
            <span>
              <GiCommercialAirplane />
            </span>
            پرواز خارجی
          </Link>
        </li>
        <li className={pathname==="/" ? "large-Screen activeReserve" : "large-Screen"}>
          <Link to="/">
            <span>
              <IoAirplaneOutline />
            </span>
            پرواز داخلی
          </Link>
        </li>
        <li className="mobile-version ">
          <Link to="plane-ticket">
            <span>
              <IoAirplaneOutline />
            </span>
            پرواز
          </Link>
        </li>
      </List>
    </Reservation>
  );
};

export default Reserve;

const Reservation = styled.div`
  width: 1120px;
  height: 106px;
  border-radius: 15px 15px 0 0;
  background-color: #ffff;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 13px -10px rgba(0, 0, 0, 0.55);

  @media (max-width: 900px) {
    width: 90vw;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 8px;
  }

  @media (min-width: 900px) and (max-width: 1120px) {
    width: 90vw;
  }
`;

const List = styled.ul`
  max-width: 850px;
  display: flex;
  margin: auto;
  justify-content: space-between;
  list-style: none;
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  padding: 20px 100px 6px 100px;

  .mobile-version {
    display: none;
  }

  @media (max-width: 900px) {
    flex-wrap: wrap;
    padding: 0px;

    .large-Screen {
      display: none;
    }
    .mobile-version {
      display: flex;
    }
  }

  li {
    cursor: pointer;
    display: flex;
    flex-direction: column;

    @media (max-width: 900px) {
      flex-direction: row-reverse;
      width: 50%;
      padding: 5px;
      justify-content: center;
      font-size: 14px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      align-items: center;
      :nth-child(2n) {
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
      :nth-child(1),
      :nth-child(2) {
        border-top: none;
      }

      &::before {
        display: none;
      }
    }
    a {
      display: flex;
      flex-direction: column;
      color: rgba(0, 0, 0, 0.8);
      text-decoration: none;

      span {
        text-align: center;
        font-size: 30px;
        color: rgba(0, 0, 0, 0.7);

        @media (max-width: 900px) {
          margin-left: 10px;
          font-size: 23px;
          vertical-align: middle;

          svg {
            vertical-align: middle;
          }
        }
      }
    }
    &::before {
      content: "";
      position: relative;
      border: 3px solid rgb(0, 119, 219);
      top: 100%;
      right: 0;
      border-radius: 5px 5px 0 0;
      transform-origin: right center;
      transform: scaleX(0);
      transition: all 250ms;
    }

    &:hover {
      span {
        color: rgb(0, 119, 219);
      }
      a {
        color: rgb(0, 119, 219);
      }
      &::before {
        transform: scaleX(1);
      }
    }
  }

  .activeReserve {
    &::before {
      content: "";
      position: relative;
      border: 3px solid rgb(0, 119, 219);
      top: 100%;
      right: 0;
      border-radius: 5px 5px 0 0;
      transform-origin: right center;
      transform: scaleX(1);
      transition: all 250ms;
    }

    span {
      color: rgb(0, 119, 219);
    }
    a {
      color: rgb(0, 119, 219);
    }
  }
`;
